<template>
  <div class="space-y-4">
    <div class="flex justify-between items-center">
      <h3 class="text-lg font-medium text-gray-900">
        Services
      </h3>
      <button
        type="button"
        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium
          rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
        @click="addService">
        <i class="fas fa-plus mr-2" />
        Add Service
      </button>
    </div>

    <div
      v-for="(service, index) in localServices"
      :key="index"
      class="bg-white shadow rounded-lg p-4">
      <div class="space-y-3">
        <div>
          <label class="block text-sm font-medium text-gray-700">
            Service Title
          </label>
          <input
            v-model="service.title"
            type="text"
            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="e.g., Residential Plumbing"
            @input="updateServices">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            v-model="service.description"
            rows="3"
            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Describe this service..."
            @input="updateServices" />
        </div>
        <button
          type="button"
          class="text-red-600 hover:text-red-800 text-sm"
          @click="removeService(index)">
          <i class="fas fa-trash mr-1" />
          Remove
        </button>
      </div>
    </div>

    <div
      v-if="localServices.length === 0"
      class="text-center py-8 text-gray-500">
      No services added yet. Click "Add Service" to get started.
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

const localServices = ref([...props.modelValue])

const updateServices = () => {
  emit('update:modelValue', [...localServices.value])
}

const addService = () => {
  localServices.value.push({ title: '', description: '' })
  updateServices()
}

const removeService = (index) => {
  localServices.value.splice(index, 1)
  updateServices()
}

watch(() => props.modelValue, (newValue) => {
  localServices.value = [...newValue]
}, { deep: true })
</script>
